import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import ScheduleSelect from './components/SelectWrap';
import Spinner from '../../../../components/Spinner/';
import LoginHOC from '../../../../components/LoginHOC';

const readAdvisorNodes = gql`
query (
  $UserID: Int!
  $ModuleID: Int!
) {
  getAdvisorScheduleNodes(userID: $UserID) {
    id
    start_timestamp
    end_timestamp
    negative_positive
    module_instance {
      id
    }
  }
  ModuleInstance(id: $ModuleID) {
    id
		scheduled_to
    Industry {
      name
    }
    student {
      id
			photo
      first_name
      last_name
    }
    advisor {
			photo
      first_name
      last_name
    }
    module {
      module_name
      duration_minutes
    }
  }
}
`;

const RequestMoreTimeMutation = gql`
mutation (
  $ModuleInstanceID: Int!
) {
  requestMoreSessionTimes (
    ModuleInstanceID: $ModuleInstanceID
  ) {
    status
  }
}
`;

const StudentScheduleTimeMutation = gql`
mutation (
  $ModuleInstanceID: Int!
  $Epoch: Int!
) {
  studentScheduleTime (
    ModuleInstanceID: $ModuleInstanceID
    Time: $Epoch
  ) {
    status
  }
}
`;

export default (store) => ({
  path: 'select/:UserID/:ModuleInstance',
  component: LoginHOC(props => {
    const Component = compose(
      graphql(readAdvisorNodes, {
        options: {
          variables: {
            UserID: props.routeParams.UserID,
            ModuleID: props.routeParams.ModuleInstance
          },
          fetchPolicy: 'network-only',
        },
      }),
      graphql(RequestMoreTimeMutation, {
        name: 'RequestMoreTime',
      }),
      graphql(StudentScheduleTimeMutation, {
        name: 'ScheduleTime',
      })
    )(GraphQLResult => {
      if (GraphQLResult.data.loading === false) {
        return <ScheduleSelect {...props} {...GraphQLResult} />;
      }
      return <Spinner style={{ marginTop: '50px' }} />;
    });

    return <Component />;
  }),
});



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SelectSlot/index.js